import React from 'react';
import css from '../less/percent.m.less';
import {Control, Table, FormError} from '@ab/components';

export default function template() {
    return (
        <div className={css.root}>
            <Control>
                <div>{this.l10n('STATEMENTS_PERCENT_HINT')}</div>
            </Control>
            <FormError error={this.getError()} />
            <Table>
                <thead>
                    <tr>
                        <th className="text-center">{this.l10n('STATEMENTS_PERCENT_TH_DATE')}</th>
                        <th className="text-center">{this.l10n('STATEMENTS_PERCENT_TH_CREDIT')}</th>
                        <th className="text-center">{this.l10n('STATEMENTS_PERCENT_TH_DEBIT')}</th>
                        <th className="text-center">
                            {this.l10n('STATEMENTS_PERCENT_TH_MIN_REST')}
                        </th>
                        <th className="text-center">
                            {this.l10n('STATEMENTS_PERCENT_TH_PAYMENT')}
                        </th>
                        <th className="text-center">{this.l10n('STATEMENTS_PERCENT_TH_SAVED')}</th>
                    </tr>
                </thead>
                <tbody>
                    {this.collection.map(model => (
                        <tr key={model.get('date')?.date()}>
                            <td className="text-right">{model.get('date')?.date()}</td>
                            <td className="text-right">
                                {model.get('amount_day_credit')?.toString()}
                            </td>
                            <td className="text-right">
                                {model.get('amount_day_debit')?.toString()}
                            </td>
                            <td className="text-right">{model.get('amount_body')?.toString()}</td>
                            <td className="text-right">
                                {model.get('amount_interest')?.toString()}
                            </td>
                            <td className="text-right">
                                {model.get('amount_interest_cumulative')?.toString()}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    );
}
